import {
  ChannelSettingDropdown,
  type OverrideValue,
} from './ChannelSettingDropdown';

export function ChannelAiAnswerSection({
  value,
  onValueChange,
  globalEnabled,
  isReadOnly = false,
}: {
  value: OverrideValue;
  onValueChange: (value: OverrideValue) => void;
  globalEnabled: boolean;
  isReadOnly?: boolean;
}) {
  return (
    <ChannelSettingDropdown
      title="Bot Answering"
      description="Override the team-wide setting for bot answering in this channel. When disabled, the bot will not automatically answer questions, but will still respond when @mentioned."
      value={value}
      onValueChange={onValueChange}
      globalEnabled={globalEnabled}
      isReadOnly={isReadOnly}
    />
  );
}
